import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.exchangePlaidError"],
  error => error
);
